module.exports = __webpack_public_path__ + "static/media/avfall.464686ed.mp3";